module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text1":"By continuing to browse, you accept our policy of","accept":"Accept"},"es":{"text1":"Al seguir navegando, aceptas nuestra política de","accept":"Aceptar"}}')
  delete Component.options._Ctor
}
